<template>
  <div class="insure-form-payment">
    <div class="loading" v-if="loading">
      <img src="@/assets/loading.gif" />
    </div>
    <div class="error-content" v-if="!loading">
      <img src="@/assets/img-status-error.png" alt="" />
      <h3>系统打了个盹</h3>
      <p>请尽快联系业务员线下缴费</p>
    </div>
  </div>
</template>

<script>
import * as services from '@/services';
import * as qs from 'qs';

export default {
  components: {},

  data() {
    return {
      loading: true,
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      const { businessNo, businessSource } = this.$route.query;
      if (businessNo.includes('||')) {
        const obj = businessNo.split('||');
        const businessNumber = obj[0];
        const token = obj[1];
        window.localStorage.setItem('authToken', token);
        services.getPayLink(businessNumber).then(res => {
          if (!res.success) {
            this.loading = false;
          } else {
            if (businessSource === 'ONLINE') {
              const url = res.content.payUrl;
              const payUrl = `${url}&businessSource=${businessSource}`;
              window.location.replace(payUrl);
            } else {
              window.location.replace(res.content.payUrl);
            }
          }
        });
      } else {
        services.getPayLink(businessNo).then(res => {
          if (!res.success) {
            this.loading = false;
          } else {
            if (businessSource === 'ONLINE') {
              const url = res.content.payUrl;
              const payUrl = `${url}&businessSource=${businessSource}`;
              window.location.replace(payUrl);
            } else {
              window.location.replace(res.content.payUrl);
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="less">
.insure-form-payment {
  display: flex;
  align-items: center;
  height: 100%;
  .loading {
    margin: 0 auto;
    img {
      width: 80vw;
    }
  }
  .error-content {
    margin: 0 auto;
    img {
      width: 60vw;
    }
    h3 {
      font-size: 20px;
      color: #434b65;
      font-weight: normal;
      text-align: center;
    }
    p {
      font-size: 14px;
      color: #808897;
      text-align: center;
    }
  }
}
</style>
